import "./ProductCards.css"
import CmsHelper, {LandingPageHelper, PickProgramPageHelper} from "../../Utilities/CmsHelpers";
import {useCms} from "../../../context/CmsContext";
import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import FlowContainer from "../../PickProgram/FlowElements/FlowContainer";
import UserService from "../../../services/UserService";
import {useAuth} from "../../../context/AuthContext";
import {useAccount} from "../../../context/AccountContext";
import AddonCard from "./components/AddonCard/AddonCard";
import {useTranslation} from "react-i18next";

function ProductCards({products: receivedProducted}){
    const {landingData, pickProgramData} = useCms();
    const productData = LandingPageHelper.getProductSection(landingData);

    const [products] = useState(receivedProducted
        // .filter(product => product.displayName !== "Lite")
    )

    const location = useLocation();
    const { t } = useTranslation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.has("scrollToPrograms")) {
            const element = document.getElementById("Programs");
            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({behavior: "smooth"});
                }, 100)
            }
        }
    }, [location.search]);


    const UpperComponent = ()=>{
        return <>
            <div className={"pickprogram-header-wrapper"}>
                <span className={"products-title"}>{
                    LandingPageHelper.getProductTtitle(productData, false)?.header
                }</span>
            </div>
        </>
    }

    const AddonContainer = ({className, style}) => {
        const addons = [...new Map(products
                .flatMap(product => product?.addons ?? [])
                .map(addon => [addon?.skuORQuickCode, addon])).values()];

        return !!addons.length && <>
            <div className={`landing-addon-container-wrapper ${className}`} style={style}>
                <span>{t("landingPageAddonHeader")}</span>
                <div className={"landing-addon-container"}>
                    {addons.map((addon, index) => <>
                        <AddonCard key={addon.skuORQuickCode} addon={addon}/>
                    </>)}
                </div>
            </div>
        </>
    }

    const navigate = useNavigate();
    const account = useAccount();
    const {setCheckLoggedIn} = useAuth();

    const cardAction = (product, setError) => {
        const Free = "Lite";

        sessionStorage.setItem("selectedProgramId", JSON.stringify(product));
        account.clearSessionCoupon();
        if (UserService.isLoggedIn()) {
            setCheckLoggedIn(true);
            navigate("/PickProgram");
        } else {
            if(product.displayName === Free){
                UserService.doRegister(
                    process.env.REACT_APP_START_FOR_FREE_REDIRECT_URI
                );
            }else {
                UserService.doRegister(
                    process.env.REACT_APP_START_FOR_NOTFREE_REDIRECT_URI
                );
            }
        }
    };

    if(!!pickProgramData.error){
        return <></>
    }
    return (
        <div className={"products-wrapper"} id={"Programs"}>
            <FlowContainer packages={products}
                           loading={false}
                           UpperComponent={UpperComponent}
                           update={false}
                           currentProgram={undefined}
                           cancellationFlow={false}
                           couponExists={false}
                           contestState={false}
                           cmsData={PickProgramPageHelper.getPrograms(pickProgramData, CmsHelper.UPGRADE_PROGRAM)}
                           onNext={cardAction}
                           AddonContainer={AddonContainer}
            />
        </div>
    )
}

export default ProductCards;